import { Size } from 'react-easy-crop/types';

export interface IImageCropper {
  showSlider?: boolean;
  aspect?: number;
  cropShape?: 'rect' | 'round';
  showGrid?: boolean;
  cropSize?: Size;
  imageUrl?: string;
  showButtons?: boolean;
  headerText?: string;
  accept?: string;
  scaleImagePx: IScaleImagePx;
  onChange: (file: any) => void;
  serverImageUrl?: string | null;
  onRemoveFile: () => void;
}

export interface IScaleImagePx {
  width: number;
  height: number;
}

export interface IImagesObject {
  companyLogo130x100?: any;
  companyLogo300x100?: any;
  companyLogo90x30?: any;
}

export enum IImagesObjectEnum {
  companyLogo130x100 = 'companyLogo130x100',
  companyLogo300x100 = 'companyLogo300x100',
  companyLogo90x30 = 'companyLogo90x30'
}

export enum IImagesBackendEnum {
  COMPANY_LOGO_300_100 = 'COMPANY_LOGO_300_100',
  COMPANY_LOGO_90_30 = 'COMPANY_LOGO_90_30',
  COMPANY_LOGO_130_100 = 'COMPANY_LOGO_130_100'
}

export enum IImageName {
  logo_130x100 = 'logo_130x100',
  logo_300x100 = 'logo_300x100',
  logo_90x30 = 'logo_90x30'
}
